import { Preferences } from '@capacitor/preferences';

export async function migrateStorage() {
    const isMigrated = localStorage.getItem('isMigrated');

    if (isMigrated == 'true') {
        return;
    }

    const keys = Object.keys(localStorage);

    if (keys.length === 0) {
        localStorage.setItem('isMigrated', 'true');
        return;
    }

    for (const key of keys) {
        const value = localStorage.getItem(key);
        if (value) {
            await Preferences.set({ key, value });
        }
        localStorage.removeItem(key);
    }

    localStorage.setItem('isMigrated', 'true');
    window.location.reload();
}
